import { render, staticRenderFns } from "./MallSide.vue?vue&type=template&id=f18b1124&scoped=true"
import script from "./MallSide.vue?vue&type=script&lang=js"
export * from "./MallSide.vue?vue&type=script&lang=js"
import style0 from "./MallSide.vue?vue&type=style&index=0&id=f18b1124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18b1124",
  null
  
)

export default component.exports